import Data from './data'

export default {
    list: () => [200, Data.list],
    get: () => [200, Data.list],
    edit: () => [200, Data.list],
    delete: () => [200, Data.list],
}
